import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {FC} from "react";

type Props = {
  content: string,
  open: boolean,
  confirmText: string,
  onConfirm: () => void,
  onClose: () => void
}
export const SimpleDialog: FC<Props> = ({content, open,confirmText, onConfirm, onClose}) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }
  return <Dialog open={open} onClose={onClose}>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <Button onClick={handleConfirm}>{confirmText}</Button>
      <Button onClick={onClose}>キャンセル</Button>
    </DialogActions>
  </Dialog>
}